import { Injectable } from '@angular/core';
import { Player } from '../models/player';
import * as _ from "lodash";
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { Router } from '@angular/router';

@Injectable()
export class SharedService {
  users
  settings
  phases = {
    preStart: 'Pre Start',
    phaseOne: 'Phase One',
    phaseTwo: 'Phase Two',
    phaseThree: 'Phase Three',
    end: 'End'
  };
  constructor(private afs: AngularFirestore, public afAuth: AngularFireAuth, private router: Router) {
    const that = this;
    this.afs.collection('users').valueChanges().subscribe(users => {
      this.users = users;
     });
     const settingsDoc = this.afs.doc('settings/' + 'yiEAeF7M7TGmk99TY1GC');
     this.settings = settingsDoc.valueChanges().subscribe(settings => {
       that.settings = settings;
     });
   }

   login() {
    const that = this;
    this.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider()).then(function() {
    if (!_.find(that.users, function(user) {
      return user.uid === that.afAuth.auth.currentUser.uid;
    })) {
      that.afs.collection('users').add({uid: that.afAuth.auth.currentUser.uid, displayName: that.afAuth.auth.currentUser.displayName});
    }}).then(function() {
      that.router.navigate(['']);
    });
  }

  logout() {
    this.afAuth.auth.signOut();
  }

  getWinningBid(player: Player) {
    if (!player || !player.bids || !player.bids.length) {
      return null;
    }
    const orderedBids = _.orderBy(player.bids, function(bid) {
      return parseInt(bid.value);
    }, 'desc');
    return orderedBids[0];
  }

  getUserById(id) {
    return _.find(this.users, function(user) {
     return user.uid === id;
    });
   }

   getPhaseForPlayer(player, clock) {
    const orderedBids = _.orderBy(player.bids, ['time'], 'desc');
    if (orderedBids.length > 0 && clock.getTime() - orderedBids[0].time < 15 * 1000 * 60) {
      return orderedBids[0].phase;
    } else {
      return this.getPhaseByTime(clock);
    }
   }

   getPhaseByTime(clock) {
    if (!this.settings || !clock) { return ''; }
    if (this.settings.startDateTime > clock.getTime()) {
      return this.phases.preStart;
    } else if (this.settings.phaseOneEndDateTime > clock.getTime()) {
      return this.phases.phaseOne;
    } else if (this.settings.phaseTwoEndDateTime > clock.getTime()) {
      return this.phases.phaseTwo;
    } else if (this.settings.draftEndDateTime > clock.getTime()) {
      return this.phases.phaseThree;
    } else {
      return this.phases.end;
    }
   }

   canUserBid(player, clock) {
     const that = this;
     return !!_.find(this.getPossibleBidders(player, clock), function(userId) {
       return userId === that.afAuth.auth.currentUser.uid;
     });
   }

   getPossibleBidders(player, clock) {
    if (!player || !clock  || !this.users || !this.settings) {
      return [];
    }
    if (this.getPhaseForPlayer(player, clock) === this.phases.phaseOne) {
      return this.getUserIds();
    }
    if (this.getPhaseForPlayer(player, clock) === this.phases.phaseTwo) {
      return this.getPhaseTwoBidders(player).players;
    }
    if (this.getPhaseForPlayer(player, clock) === this.phases.phaseThree) {
      return this.getPhaseThreeBidders(player);
    }
    return [];
   }

   getPhaseTwoBidders(player: Player) {
     const that = this;
      let phaseOneBids = _.filter(player.bids, function(bid) {
        return bid.phase === that.phases.phaseOne;
      });
       phaseOneBids = _.orderBy(phaseOneBids, ['value'], 'desc');
       const phaseTwoBidders = [];
       _.each(phaseOneBids, function(bid) {
         if (!_.find(phaseTwoBidders, function(teamId) { return teamId === bid.teamId; })) {
           phaseTwoBidders.push(bid.teamId);
         }
       });
       if (phaseTwoBidders.length < 2) {
         return {players : this.getUserIds(), type: '<2'};
       } else if (phaseTwoBidders.length < 5) {
        return {players: phaseTwoBidders, type: '<5'};
       } else {
        const length = phaseTwoBidders.length;
        return {players: phaseTwoBidders.slice(0, Math.round(length / 2)), type: '>=5'};
       }
    }

    getPhaseThreeBidders(player) {
      const that = this;
      const phaseTwoBidders = this.getPhaseTwoBidders(player);
      const phaseOneAndTwoBids = _.filter(player.bids, function(bid) {
        return bid.phase === that.phases.phaseOne || bid.phase === that.phases.phaseTwo;
      });
      const orderedBids = _.orderBy(phaseOneAndTwoBids, ['value'], 'desc');
      const orderedBidders = [];
      _.each(orderedBids, function(bid) {
        if (!_.find(orderedBidders, function(teamId) { return teamId === bid.teamId; })) {
          orderedBidders.push(bid.teamId);
        }
      });
      if (phaseTwoBidders.type === '>=5') {
        return orderedBidders.slice(0, 3);
      } else if (phaseTwoBidders.type === '<5') {
        return orderedBidders.slice(0, 2);
      } else {
        if (orderedBidders.length <= 2) {
          return this.getUserIds();
        } else {
          return orderedBidders.slice(0, 2);
        }
      }
    }

    getUserIds() {
      const userIds = [];
      _.each(this.users, function(user) {
        userIds.push(user.uid);
      });
      return userIds;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/shared.service.ts